import { apiRequest } from './axiosConfig';

/**
 * POST /api/onboarding/complete のリクエストボディ。
 *
 * バックエンド側 OnboardingCompleteRequest のルールに合わせる:
 * - company_name: required|string|max:255
 * - name: nullable|string|max:100
 * - invitation_code: nullable|string|max:50
 * - partner_ref: nullable|string|regex:/^[A-Za-z0-9_-]{1,64}$/
 * - trial_days: nullable|integer|in:7,14,30
 * - invite_ref: nullable|string|regex:/^[A-Za-z0-9]{1,32}$/
 */
export interface OnboardingCompleteRequest {
  company_name: string;
  name?: string;
  invitation_code?: string;
  partner_ref?: string;
  /** 延長トライアル招待URL経由の希望日数。許可判定はサーバー側で行う。 */
  trial_days?: number;
  /** 友だち紹介URL(?invite_ref=CODE)経由の帰属コード。有効性はサーバー側で判定。 */
  invite_ref?: string;
}

/**
 * POST /api/onboarding/complete のレスポンス。
 * OnboardingController::complete の JSON 構造に準拠。
 */
export interface OnboardingCompleteResponse {
  organization: {
    id: number;
    name: string;
  };
  user: {
    id: number;
    name: string;
    email: string;
    organization_id: number;
    role: string;
  };
  redirect: string;
}

/**
 * 企業情報オンボーディング完了。
 *
 * Magic Link / Google 認証後、/onboarding で入力された会社名 + 任意情報を
 * バックエンドへ送信し、Organization 作成 + User 紐付けを行う。
 *
 * 認証は axiosConfig のインターセプタが付与する Bearer トークンに依存。
 *
 * 既存の onboardingService.ts（LP 診断 B パターン専用・認証不要）と
 * 役割が異なるため、意図的にファイルを分けている。
 */
export const completeOnboarding = async (
  data: OnboardingCompleteRequest,
): Promise<OnboardingCompleteResponse> => {
  return apiRequest.post<OnboardingCompleteResponse>('onboarding/complete', data);
};

const onboardingCompletionService = {
  completeOnboarding,
};

export default onboardingCompletionService;
